"use client";

import type { PropsWithChildren } from "react";

import { cn } from "../../utils";
import { useCheckboxRootContext } from "./context";
import { labelStyles } from "./style";

export type CheckboxDescriptionProps = PropsWithChildren;

export const Description = (props: CheckboxDescriptionProps) => {
  const { size } = useCheckboxRootContext();

  return (
    <p
      className={cn(
        labelStyles({ size }),
        "font-normal text-neutral-60",
        "group-aria-disabled:cursor-not-allowed group-aria-disabled:text-neutral-80"
      )}
    >
      {props.children}
    </p>
  );
};
